export default __webpack_public_path__ + "src/assets/contactImport2.png";